// react
// dependencies
import { List } from "immutable";
import PropTypes from "prop-types";
import React from "react";

// components
import EmployeePicker from "../../../../../components/EmployeePicker/compatibility";

// config
import Config from "../../Config";

export default class SignatureSteps extends React.PureComponent {
	static propTypes = {
		onChange: PropTypes.func.isRequired,
		name: PropTypes.string.isRequired,
		steps: PropTypes.instanceOf(List).isRequired,
	};

	handleChange = (stepIndex, value) => {
		this.props.onChange(stepIndex, value);
	};

	render() {
		const { steps, name } = this.props;

		return (
			<div className="mt-[10px] ml-[65px] border-t border-neutral-1">
				<div className="mb-2.5 text-[13px] font-semibold text-primary-5">{name}</div>

				<div className="space-y-1.5">
					{steps.map((step, ii) => (
						<div key={step.get("index")} className="flex items-center">
							<div className="w-16 text-[13px] font-semibold text-neutral-8">Signer {ii + 1}</div>

							<EmployeePicker
								prependOptions={Config.signaturePrependOptions}
								onChange={(value) => this.handleChange(step.get("index"), value)}
								value={step.get("signer")}
								showWarning={step.get("signer") === ""}
							/>
						</div>
					))}
				</div>
			</div>
		);
	}
}
